@reference "@glow/tailwind-config/reference.css";

.modalContainer {
  @apply mx-6;
  @apply sm:mx-0;
  @apply relative;
  @apply rounded-sm;
  @apply shadow-dark;
  @apply bg-theme-surface;
  @apply max-h-[90vh];
}

.modalContainer.small {
  @apply w-[568px];
}
.modalContainer.medium {
  @apply w-[774px];
}
.modalContainer.large {
  @apply w-[1200px];
  @apply 2xl:w-[1500px];
}

.modalContainer.xl {
  @apply w-[90vw];
  @apply h-[90vh];
}

.buttons {
  @apply flex;
  @apply sticky;
  @apply bg-white;
  @apply bottom-0;
  box-shadow:
    -4px 0px 0px 0px white,
    4px 0px 0px 0px white;
  @apply flex-col-reverse;
  @apply sm:flex-row;
  @apply gap-4;
  @apply justify-end;
  @apply text-sm;
  @apply border-t;
  @apply border-gray-300;
  @apply border-solid;
  @apply py-4;
  @apply mt-6;
}
